import React, { useEffect, useState } from "react";
import { Phone, Mail, MapPin, Clock, MessageCircle, HelpCircle } from "lucide-react";
import LeadForm from "../components/LeadForm";
import { waLink, api } from "../lib/api";
import Seo from "../components/Seo";

export default function Contact() {
  const [faqs, setFaqs] = useState([]);
  const [cfg, setCfg] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    api.get("/faqs").then(r => setFaqs(r.data));
    api.get("/config").then(r => setCfg(r.data));
  }, []);

  const PHONE = cfg?.phone || "+91 72900 46341";
  const EMAIL = cfg?.email || "travels@acchajeemail.com";
  const ADDRESS = cfg?.address || "Mile Stone, 1/2, Khandsa Rd, near Sector 10 A Market, opposite Canara Bank Back Side, Pace City I, Sector 37, Gurugram, Haryana 122004";
  const HOURS = cfg?.hours || "Mon–Sat: 10:00 AM – 6:00 PM";
  const MAP = cfg?.map_embed || "";

  return (
    <div className="pt-24 lg:pt-28">
      <Seo title="Contact Us" path="/contact" description="Contact Acchajee Travels — call, WhatsApp or email our travel experts. We respond within 30 minutes on business days. Free custom quotes." />
      <section className="container-p">
        <span className="section-label">Contact Us</span>
        <h1 className="h1 mt-3">Let's plan your next journey</h1>
        <p className="muted mt-4 max-w-2xl">Reach out via WhatsApp, phone, email or the form below. Our travel experts respond within 30 minutes on business days.</p>
        {cfg?.tagline && <p className="mt-6 text-sm font-semibold tracking-[0.2em] uppercase text-[#FF7D00]" data-testid="contact-tagline">{cfg.tagline}</p>}
      </section>

      <section className="container-p mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { icon: Phone, label: "Call us", value: PHONE, href: `tel:${PHONE}` },
          { icon: MessageCircle, label: "WhatsApp", value: "Chat instantly", href: waLink() },
          { icon: Mail, label: "Email", value: EMAIL, href: `mailto:${EMAIL}` },
          { icon: Clock, label: "Hours", value: HOURS, href: "#" },
        ].map((c, i) => (
          <a key={c.label} href={c.href} target={c.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className="card-glass p-6 hover:-translate-y-1 transition" data-testid={`contact-${c.label.toLowerCase().replace(/\s+/g,'-')}`}>
            <c.icon className="w-7 h-7 text-[#FF7D00] mb-4" strokeWidth={1.5} />
            <div className="text-xs uppercase tracking-widest muted">{c.label}</div>
            <div className="font-display font-semibold text-[#0A2540] mt-1">{c.value}</div>
          </a>
        ))}
      </section>

      <section className="container-p mt-12 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 card-glass p-8 md:p-10"><LeadForm title="Send us a message" source="contact" /></div>
        <div className="card-glass overflow-hidden">
          {MAP && <iframe title="Acchajee Travels Office" src={MAP} width="100%" height="300" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />}
          <div className="p-6">
            <div className="flex items-start gap-2 text-sm"><MapPin className="w-4 h-4 text-[#FF7D00] mt-0.5 flex-shrink-0" /> <span>{ADDRESS}</span></div>
          </div>
        </div>
      </section>

      <section className="section container-p">
        <div className="mb-8"><span className="section-label">FAQs</span><h2 className="h2 mt-2">Frequently asked questions</h2></div>
        <div className="space-y-3 max-w-3xl">
          {faqs.map((f, i) => (
            <button key={f.id} onClick={() => setOpen(open === i ? null : i)} className="w-full card-glass p-5 text-left" data-testid={`faq-${f.id}`}>
              <div className="flex items-start justify-between gap-4"><span className="font-semibold text-[#0A2540]">{f.q}</span><HelpCircle className={`w-5 h-5 text-[#FF7D00] flex-shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`} /></div>
              {open === i && <p className="muted mt-3 text-sm leading-relaxed">{f.a}</p>}
            </button>
          ))}
        </div>
      </section>
    </div>
  );
}
